export function quotesSlider() {

    $(".quotes-slider").each(function() {
        const sliderWrapItem = $(this);
        const slider = sliderWrapItem.find(".slides");

        slider.slick({
            infinite: false,
            slidesToScroll: 1,
            dots: true,
            arrows: false
        });
    });
}



// WEBPACK FOOTER //
// ./assets/js/modules/quotes-slider.js